// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.COB629RdIXnGJ0KKJC0A{
    display: flex;
    flex-direction: column;
    padding: 0px;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    margin-top: 0px;
    margin-bottom: 0px;
    flex-flow: column nowrap;
    border: none;
    padding-top: 24px; 
    padding-bottom: 8px;
    flex-grow: 1;
    background-color: var(--background-whatsapp-conversation);
}

.COB629RdIXnGJ0KKJC0A::-webkit-scrollbar {
    width: 6px;
}

.COB629RdIXnGJ0KKJC0A::-webkit-scrollbar-track {
    background: transparent; /* Color of the scrollbar track */
}

.COB629RdIXnGJ0KKJC0A::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-regular); /* Color of the scrollbar itself */
}

.COB629RdIXnGJ0KKJC0A::-webkit-scrollbar-thumb:hover {
    background-color: var(--scrollbar-hover); /* Color on hover */
}

.COB629RdIXnGJ0KKJC0A::-webkit-scrollbar-thumb:active {
    background-color: var(--scrollbar-onClick); /* Color on click */
}

.COB629RdIXnGJ0KKJC0A::-webkit-scrollbar-corner {
    background-color: transparent; /* Set the corner color to match your design */
}

.COB629RdIXnGJ0KKJC0A > :first-child{
    margin-top: auto !important;
}

.QXT4Wrh94U1ZnnoD09CA{
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    width:100%;
    margin-bottom: 16px;

}

.sfb_T2EBTQjWKaBFXhf5, .SZmiSyGmscQe0FbylHHy{
    display: flex;
    flex-direction: row;
    white-space: pre-line;
    scrollbar-width:none;
    flex-grow: 0;
    box-sizing: border-box;
    overflow-wrap: break-word;
    word-break: break-word;
    box-sizing: border-box;
    font-size: 14px;
    padding: 16px 20px 20px 16px;
    margin-bottom: 8px;
    position: relative;
}

.sfb_T2EBTQjWKaBFXhf5{
    background-color: var(--background-bot-message);
    color: var(--letter-dark);  
    border-bottom-right-radius: 0px;
    box-shadow: 2px 5px 5px rgba(0,0,0,0.2);
    font-weight: 500;
    margin-left: auto;
    margin-right: 24px;
    margin-bottom: 8px;
    border-top-left-radius: 8px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}
    

.SZmiSyGmscQe0FbylHHy{
    background-color: var(--user-message);
    color: var(--letter-dark);   
    border-top-left-radius: 0px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: -2px 5px 5px rgba(0,0,0,0.2);
    min-width: 90px;
    margin-right: 72px;
    margin-left: 24px;
}

.wHNYOwLjXDIDMa9Wx5nZ{
    color: var(--letter-medium);
    font-size: 11px;
    position: absolute;
    right: 8px;
    bottom: 4px;
}

.yR34bWczKXIdIH0dmyf4{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 8px;
    margin-top: 8px;
}

.nv3Ncl3A2ldEPE8zpxQf{
    color: var(--letter-medium);
    font-size: 12px;
    padding: 8px;
    border-radius: 8px;
    background-color: var(--user-message);
    border-radius: 8px;
    width: auto;

}`, "",{"version":3,"sources":["webpack://./clientRoot/Static/WorkingArea/ServiceOrderManagement/ChatWindows/ChatConversation/ChatConversation.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,yDAAyD;AAC7D;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB,EAAE,iCAAiC;AAC9D;;AAEA;IACI,0CAA0C,EAAE,kCAAkC;AAClF;;AAEA;IACI,wCAAwC,EAAE,mBAAmB;AACjE;;AAEA;IACI,0CAA0C,EAAE,mBAAmB;AACnE;;AAEA;IACI,6BAA6B,EAAE,8CAA8C;AACjF;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,+BAA+B;IAC/B,uCAAuC;IACvC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;AACnC;;;AAGA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,wCAAwC;IACxC,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;;AAEf","sourcesContent":[".conversationContainer{\n    display: flex;\n    flex-direction: column;\n    padding: 0px;\n    width: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    box-sizing: border-box;\n    margin-top: 0px;\n    margin-bottom: 0px;\n    flex-flow: column nowrap;\n    border: none;\n    padding-top: 24px; \n    padding-bottom: 8px;\n    flex-grow: 1;\n    background-color: var(--background-whatsapp-conversation);\n}\n\n.conversationContainer::-webkit-scrollbar {\n    width: 6px;\n}\n\n.conversationContainer::-webkit-scrollbar-track {\n    background: transparent; /* Color of the scrollbar track */\n}\n\n.conversationContainer::-webkit-scrollbar-thumb {\n    background-color: var(--scrollbar-regular); /* Color of the scrollbar itself */\n}\n\n.conversationContainer::-webkit-scrollbar-thumb:hover {\n    background-color: var(--scrollbar-hover); /* Color on hover */\n}\n\n.conversationContainer::-webkit-scrollbar-thumb:active {\n    background-color: var(--scrollbar-onClick); /* Color on click */\n}\n\n.conversationContainer::-webkit-scrollbar-corner {\n    background-color: transparent; /* Set the corner color to match your design */\n}\n\n.conversationContainer > :first-child{\n    margin-top: auto !important;\n}\n\n.message{\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    margin: 0px;\n    padding: 0px;\n    box-sizing: border-box;\n    width:100%;\n    margin-bottom: 16px;\n\n}\n\n.messageContentQuoteMaster, .messageContentProvider{\n    display: flex;\n    flex-direction: row;\n    white-space: pre-line;\n    scrollbar-width:none;\n    flex-grow: 0;\n    box-sizing: border-box;\n    overflow-wrap: break-word;\n    word-break: break-word;\n    box-sizing: border-box;\n    font-size: 14px;\n    padding: 16px 20px 20px 16px;\n    margin-bottom: 8px;\n    position: relative;\n}\n\n.messageContentQuoteMaster{\n    background-color: var(--background-bot-message);\n    color: var(--letter-dark);  \n    border-bottom-right-radius: 0px;\n    box-shadow: 2px 5px 5px rgba(0,0,0,0.2);\n    font-weight: 500;\n    margin-left: auto;\n    margin-right: 24px;\n    margin-bottom: 8px;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 0px;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n}\n    \n\n.messageContentProvider{\n    background-color: var(--user-message);\n    color: var(--letter-dark);   \n    border-top-left-radius: 0px;\n    border-top-right-radius: 8px;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    box-shadow: -2px 5px 5px rgba(0,0,0,0.2);\n    min-width: 90px;\n    margin-right: 72px;\n    margin-left: 24px;\n}\n\n.messageTime{\n    color: var(--letter-medium);\n    font-size: 11px;\n    position: absolute;\n    right: 8px;\n    bottom: 4px;\n}\n\n.dateLine{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    margin: 0px;\n    padding: 0px;\n    box-sizing: border-box;\n    width: 100%;\n    margin-bottom: 8px;\n    margin-top: 8px;\n}\n\n.date{\n    color: var(--letter-medium);\n    font-size: 12px;\n    padding: 8px;\n    border-radius: 8px;\n    background-color: var(--user-message);\n    border-radius: 8px;\n    width: auto;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"conversationContainer": `COB629RdIXnGJ0KKJC0A`,
	"message": `QXT4Wrh94U1ZnnoD09CA`,
	"messageContentQuoteMaster": `sfb_T2EBTQjWKaBFXhf5`,
	"messageContentProvider": `SZmiSyGmscQe0FbylHHy`,
	"messageTime": `wHNYOwLjXDIDMa9Wx5nZ`,
	"dateLine": `yR34bWczKXIdIH0dmyf4`,
	"date": `nv3Ncl3A2ldEPE8zpxQf`
};
export default ___CSS_LOADER_EXPORT___;
